import { Avatar, CircularProgress, Skeleton, Typography } from '@mui/material';

const PostSkeleton = () => {
    return <div style={{ padding: '12px' }}>
        <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
            <Skeleton variant="circular">
                <Avatar />
            </Skeleton>
            <Skeleton width="30%">
                <Typography>.</Typography>
            </Skeleton>
        </div>
        <Skeleton variant="rectangular" width="100%" style={{ padding: '40px 10px' }}>
            <CircularProgress
                style={{ visibility: 'visible' }}
                size={32}
            />
        </Skeleton>
    </div>;
};

export default PostSkeleton;